import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { BaseComponent } from '../../../../shared/base-components/base.component';

export class AlertModalData {
    constructor(public title: string, public header: string, public message: string, public buttonText: string, public okButtonText: string, public showOkButton: boolean) {}
}

@Component({
    selector: 'alert-modal',
    templateUrl: './alert-modal.html'
})

export class AlertModalComponent extends BaseComponent {
    public dataLoaded = false;

    constructor(public dialogRef: MatDialogRef<AlertModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: AlertModalData) {
        super();
    }

    // Initialize the class
    ngOnInit() {
        const self = this;
        self.dataLoaded = true;

        // show any validation when modal is loaded
    }

    close() {
        this.dialogRef.close();
    }

    accept() {
        this.dialogRef.close(true);
    }

}
